// easyui-splitbutton.component.ts
// (c) 2017 EvoluS Srl
// (a) VG

import { Component, ElementRef, Input, ViewChild, AfterViewInit } from '@angular/core';
import { Globs } from '../globs';

declare let $: any;

@Component({
  selector: 'easyui-splitbutton',
  template: `
    <div #host>{{title}}
    </div>
    <div id='{{id}}'>
    <ng-content></ng-content>
  </div>
`
})
export class EasyuiSplitbuttonComponent implements AfterViewInit {
  private host: any;
  id = Globs.uuidGen();
  @Input() options: any = {};
  @Input() icon: string;
  @Input() title: string;
  @ViewChild('host') hostElement: ElementRef;

  constructor() {}

  ngAfterViewInit() {
    this.configura(this.options);
  }

  public styleElement( tag: string, css: any) {
    const element = this.host.find(tag);
    element.css(css);
  }

  private configura(options: any) {
    this.host = $(this.hostElement.nativeElement);
    options.menu = '#' + this.id;
    if (this.icon) { options.iconCls = this.icon; }
    this.host.splitbutton(options);
  }
}



// WEBPACK FOOTER //
// ./src/app/easyui-ts/easyui-splitbutton.component.ts